import CONFIG from './config'

const ApiEndpoint = {
  HOME: `${CONFIG.BASE_URL}/list`,
  DETAIL: (id) => `${CONFIG.BASE_URL}/detail/${id}`,
  POST: `${CONFIG.BASE_URL}/review`
}

export default ApiEndpoint
